import axios from 'axios';
import { API_BASE_URL } from './apiService';

// Create axios instance with increased timeout for Render free tier cold starts
const documentsAxios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 seconds for Render free tier
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
documentsAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const documentsService = {
  // Get all documents
  async getDocuments() {
    const response = await documentsAxios.get('/documents/');
    return response.data;
  },

  // Get documents by reference
  async getDocumentsByReference(referenceType: string, referenceId: number) {
    const response = await documentsAxios.get(`/documents/reference/${referenceType}/${referenceId}`);
    return response.data;
  },

  // Get single document
  async getDocument(documentId: number) {
    const response = await documentsAxios.get(`/documents/${documentId}`);
    return response.data;
  },

  // Upload document
  async uploadDocument(formData: FormData) {
    const response = await documentsAxios.post('/documents/upload/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Download document
  async downloadDocument(documentId: number): Promise<Blob> {
    const response = await documentsAxios.get(`/documents/${documentId}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // Delete document
  async deleteDocument(documentId: number) {
    const response = await documentsAxios.delete(`/documents/${documentId}`);
    return response.data;
  },

  // Update document metadata
  async updateDocument(documentId: number, updateData: any) {
    const response = await documentsAxios.put(`/documents/${documentId}`, updateData);
    return response.data;
  },
};